import { loader } from "@monaco-editor/react";
import monaco from "monaco-editor";
import store from "../../../store";
import { editExpressionAtLine } from "../store/expressionEditorSlice";
import { EditorVariant } from "../types";
import provideCompletionItems from "./editorUtils/provideCompletionItems";
import provideCompletionVariant from "./editorUtils/provideCompletionVariant";
import formDefinitionJsonSchema from "./jsonSchema/formDefinitionJsonSchema";
import formDefinitionLayoutJsonSchema from "./jsonSchema/formDefinitionLayoutJsonSchema";
import formDefinitionOptionsJsonSchema, {
  FORM_DEFINITION_OPTIONS_MODEL_URI,
} from "./jsonSchema/formDefinitionOptionsJsonSchema";
import formDefinitionSchemaJsonSchema, {
  FORM_DEFINITION_SCHEMA_MODEL_URI,
} from "./jsonSchema/formDefinitionSchemaJsonSchema";

var commandId = "command";

loader
  .init()
  .then((monaco) => {
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      validate: true,
      schemaValidation: "error",
      schemas: [
        formDefinitionJsonSchema,
        formDefinitionSchemaJsonSchema,
        formDefinitionLayoutJsonSchema,
        formDefinitionOptionsJsonSchema,
      ],
    });
    monaco.languages.registerCompletionItemProvider("json", {
      provideCompletionItems,
    });
    monaco.languages.registerCompletionItemProvider("json", {
      provideCompletionItems: provideCompletionVariant,
    });
    monaco.editor.registerCommand(commandId, (accessor, ...args) => {
      let parsedExpression: string = "";

      parsedExpression = JSON.parse('"' + args[1] + '"');

      store.dispatch(
        editExpressionAtLine({
          line: args[0],
          content: parsedExpression,
          editorVariant: args[2],
        })
      );
    });
    monaco.languages.registerCodeLensProvider("json", {
      provideCodeLenses: function (
        model: monaco.editor.ITextModel,
        token: monaco.CancellationToken
      ): monaco.languages.ProviderResult<monaco.languages.CodeLensList> {
        const value = model?.getValue();
        const jsonLines = value?.split(/\r\n|\r|\n/) || [];
        const uri = `${model.uri.scheme}://${model.uri.authority}${model.uri.path}`;
        if (uri === FORM_DEFINITION_OPTIONS_MODEL_URI)
          return { lenses: [], dispose: () => {} };

        return {
          lenses: getLenses(jsonLines, uri),
          dispose: () => {},
        };
      },
    });
  })
  .catch((error) =>
    console.error("An error occurred during initialization of Monaco: ", error)
  );
const FormEditorConfig = () => {
  return null;
};
const getLenses = (
  editorLines: string[],
  uri: string
): monaco.languages.CodeLens[] => {
  const lenses: monaco.languages.CodeLens[] = [];

  editorLines.forEach((line, index) => {
    if (
      line.includes("expression") ||
      line.includes("dependsOn") ||
      line.includes("visibility") ||
      line.includes("readonly") ||
      line.includes("computedExpression")
    ) {
      const matchedArray = line.match(
        /^\s*"(.*)"\s*:\s*(?:"(.*)"|(true|false))/
      );
      let content;
      if (matchedArray) {
        if (!matchedArray[2]) {
          // Boolean value
          content = matchedArray[3] === "true";
        } else {
          content = matchedArray[2];
          // .replaceAll('\\"', '"')
          // .replaceAll("\\\\", "\\");
        }
      }
      lenses.push({
        range: {
          startLineNumber: index + 1,
          startColumn: 1,
          endLineNumber: index + 2,
          endColumn: 1,
        },
        id: commandId,
        command: {
          id: commandId,
          title: "Edit",
          arguments: [
            index,
            content,
            uri === FORM_DEFINITION_SCHEMA_MODEL_URI
              ? EditorVariant.Schema
              : EditorVariant.Layout,
          ],
        },
      });
    }
  });

  return lenses;
};
export default FormEditorConfig;
